import {api} from "./api";
import {MODERATOR_VICTIM, MODERATOR_VICTIM_STATUS, MODERATOR_VICTIM_TYPE} from "../mock/URLs";
import {GetVictimResponse} from "../types/victim";

export const getVictims = async ({params}) => {
  try {
    const {data} = await api.get(MODERATOR_VICTIM, {params})
    return data
  } catch (e) {
    throw e
  }
}

export const getVictimById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: GetVictimResponse }>(`${MODERATOR_VICTIM}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}

export const updateVictim = async (id: number, values) => {
  try {
    const {data} = await api.patch(`${MODERATOR_VICTIM}${id}/`, values)
    return data.data
  } catch (e) {
    throw e
  }
}

//victim types
export const getVictimTypes = async ({params}) => {
  try {
    const {data} = await api.get(MODERATOR_VICTIM_TYPE, {
      params
    })
    return data
  } catch (e) {
    throw e
  }
}

export const createVictimType = async (values) => {
  try {
    const {data} = await api.post(MODERATOR_VICTIM_TYPE, values)
    return data.data
  } catch (e) {
    throw e
  }
}

export const getVictimTypeById = async (id: number) => {
  try {
    const {data} = await api.get(`${MODERATOR_VICTIM_TYPE}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}

export const updateVictimType = async (id: number, values) => {
  try {
    const {data} = await api.patch(`${MODERATOR_VICTIM_TYPE}${id}/`, values)
    return data.data
  } catch (e) {
    throw e
  }
}


//victim status
export const getVictimStatuses = async ({params}) => {
  try {
    const {data} = await api.get(MODERATOR_VICTIM_STATUS, {
      params
    })
    return data
  } catch (e) {
    throw e
  }
}

export const createVictimStatus = async (values) => {
  try {
    const {data} = await api.post(MODERATOR_VICTIM_STATUS, values)
    return data.data
  } catch (e) {
    throw e
  }
}

export const getVictimStatusById = async (id: number) => {
  try {
    const {data} = await api.get(`${MODERATOR_VICTIM_STATUS}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}

export const updateVictimStatus = async (id: number, values) => {
  try {
    const {data} = await api.patch(`${MODERATOR_VICTIM_STATUS}${id}/`, values)
    return data.data
  } catch (e) {
    throw e
  }
}